import { render, staticRenderFns } from "./HeaderColumns.vue?vue&type=template&id=34d7375d&"
import script from "./HeaderColumns.vue?vue&type=script&lang=js&"
export * from "./HeaderColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports